import styled, { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import {
  format,
  addDays,
  getWeeksInMonth,
  getDate,
  startOfMonth,
  getDaysInMonth,
  startOfWeek,
  setDay,
  getDay,
  getMonth,
} from "date-fns";
import { he, enUS } from "date-fns/locale";

const DayDiv = styled.div(() => ({
  borderRadius: 0,
  border: `1px solid #E9E9E9`,
  height: 160,
  width: "100%",
}));

const StandardDiv = styled.div(() => ({
  borderRadius: 4,
  border: `1px solid #E86520`,
  height: 28,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  fontSize: 14,
  margin: 5,
  color: "#E86520",
}));

const HoursDiv = styled.div(({ width, theme }) => ({
  borderRadius: 4,
  background: "#E86520",
  height: 22,
  width: width,
  margin: 2,
  color: theme.color.white,
  fontSize: 12,
  padding: 2,
}));

const ABSDiv = styled.div(({ width, theme, color }) => ({
  borderRadius: 4,
  background: color,
  height: 22,
  width: width,
  color: theme.color.white,
  fontSize: 12,
  padding: 2,
  margin: 5,
}));

const Header = ({ days, userStore }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      {days.map((day, index) => {
        return (
          <div style={{ width: 216, textAlign: "center" }} key={index}>
            {format(day, "EEEE", {
              locale: userStore.language === "he" ? he : enUS,
            })}{" "}
          </div>
        );
      })}
    </div>
  );
};

const Day = ({ day, date, data }) => {
  const { t } = useTranslation("month_reports");
  const theme = useTheme();
  const inDate = getMonth(day) === getMonth(date);
  return (
    <DayDiv>
      <div
        style={{
          margin: 5,
          color: inDate ? theme.color.text : theme.color.gray,
        }}>
        {getDate(day)}
      </div>
      {inDate && (
        <div>
          {data?.STANDARD > 0 && (
            <StandardDiv>
              {data?.HOURS > 0 && (
                <HoursDiv
                  width={`${
                    ((data?.EXTRA > 0
                      ? data?.HOURS - data?.EXTRA
                      : data?.HOURS) /
                      data?.STANDARD) *
                    100
                  }%`}>
                  {t("hours_hours", {
                    hours:
                      data?.EXTRA > 0 ? data?.HOURS - data?.EXTRA : data?.HOURS,
                  })}
                </HoursDiv>
              )}
              {data?.HOURS < data?.STANDARD && (
                <div style={{ padding: 2, whiteSpace: "nowrap" }}>
                  {t("standard_hours", { hours: data?.STANDARD })}
                </div>
              )}
            </StandardDiv>
          )}
          {data?.EXTRA > 0 && (
            <ABSDiv color="#4A69A6">
              {t("extra_hours", { hours: data?.EXTRA })}
            </ABSDiv>
          )}
          {data?.VAC > 0 && (
            <ABSDiv color="#E214E7">
              {t("vacation_hours", { hours: data?.VAC })}
            </ABSDiv>
          )}
          {data?.ILL > 0 && (
            <ABSDiv color="#E7B814">
              {t("illnace_hours", { hours: data?.ILL })}
            </ABSDiv>
          )}
          {data?.SERV > 0 && (
            <ABSDiv color="#293041">
              {t("serveice_hours", { hours: data?.SERV })}
            </ABSDiv>
          )}
          {!!data?.HOLIDAYDES && (
            <ABSDiv color="#63D09C">{data?.HOLIDAYDES}</ABSDiv>
          )}
        </div>
      )}
    </DayDiv>
  );
};

const Week = ({ days, date }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
      {days.map((day, index) => {
        return <Day day={day.day} key={index} date={date} data={day.data} />;
      })}
    </div>
  );
};

const Calender = ({ date, data, userStore }) => {
  const days = [];
  const weeks = [];
  const daysInMonthArray = [];

  let startDate = startOfMonth(date);
  const firstSunday = setDay(startDate, 0, { weekStartsOn: getDay(startDate) });
  const dayInMonth = getDaysInMonth(date);
  const startWeek = startOfWeek(startDate);

  for (let i = 0; i < 7; i++) {
    days.push(addDays(firstSunday, i));
  }

  for (let i = 0; i < dayInMonth; i++) {
    daysInMonthArray.push(addDays(startDate, i));
  }

  for (let i = 0; i < getWeeksInMonth(startDate); i++) {
    weeks.push(addDays(startWeek, i * 7));
  }

  return (
    <div>
      <Header days={days} userStore={userStore}></Header>
      <div
        style={{
          height: "70vh",
          overflow: "auto",
        }}>
        {weeks.map((week, index) => {
          let innerDays = [];

          for (let i = 0; i < 7; i++) {
            let day = addDays(week, i);
            let dayData = data?.find((report) => {
              return (
                getDate(new Date(report.CURDATE)) === getDate(new Date(day))
              );
            });
            innerDays.push({ day: day, data: dayData });
          }
          return <Week key={index} days={innerDays} date={date} />;
        })}
      </div>
    </div>
  );
};

export default Calender;
